import React from 'react'
import { connect } from 'react-redux'
import StyleableModal from 'components.v2/Modal/StylableModal'
import styled from 'styled-components'
import { compose } from 'recompose'
import { withRouter } from 'react-router'

const Modal = styled(StyleableModal)`
  &__content {
    position: relative;
    display: block;
    max-width: 320px;
    width: 100%;
    background-color: ${(p) => p.theme.colors.white};
    outline: none !important;
    border-radius: 12px;
    overflow: hidden;

    div[class*='ShadowCardContainer'] {
      box-shadow: none;
      width: 100%;
    }
  }

  &__overlay {
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgba(0, 0, 0, 0.66);
    position: fixed;
    z-index: 10000;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
  }
`

const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 28px;
  padding-bottom: 20px;

  & > .text-content {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 4px;

    font-family: Montserrat;
    text-align: center;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    width: 280px;

    .heading {
      font-size: 24px;
      font-weight: 700;
      line-height: 32px;
      color: #000000;
    }

    .subheading {
      font-weight: 400;
      line-height: 20px;
      font-size: 14px;
      color: #666666;

      span > a {
        text-decoration: underline;
        color: #2e9a9a;
      }
    }
  }

  & > .button {
    width: 280px;
    display: flex;
    flex-direction: column;
    gap: 4px;

    img {
      :hover {
        cursor: pointer;
      }
    }
  }
`

const Button = styled.button`
  border-radius: 8px;
  outline: none;
  height: 52px;

  font-family: Montserrat;
  font-size: 18px;
  font-weight: 700;
  line-height: 24px;
  text-align: center;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;

  ${(p) =>
    p.variant === 'secondary'
      ? `
    color: #999999;
    `
      : `
    color: ${p.color || '#FFFFFF'} ;
    background: ${p.background || '#F26722'} ;
    `}

  :focus {
    outline: none;
  }

  :hover {
    background: ${(p) =>
      p.variant === 'primary' ? p.theme.colors['primaryDarker'] : '#0000001a'};
  }

  :active {
    background: #00000033;
  }
`

const PopupAds = ({ source, title, message, link, cta, history, ...aaaa }) => {
  const handleHide = () => {
    history.push(history.location.pathname)
  }

  const handleCta = () => {
    window.location.href = cta.primary.action
  }

  return (
    <Modal
      isOpen
      contentLabel="Serving To Table"
      onRequestClose={handleHide}
      prependClassName="text-center"
      small
      noCloseButton
    >
      <Content>
        <img src={source}></img>
        <div className="text-content">
          <div className="heading">{title}</div>
          <div className="subheading">
            {message}{' '}
            <span>
              <a href={link.source}>{link.text}</a>
            </span>
          </div>
        </div>

        <div className="button">
          {cta.primary.type === 'text' ? (
            <Button
              className="w-full"
              onClick={handleCta}
              variant="primary"
              background={cta.primary.background}
              color={cta.primary.textColor}
            >
              {cta.primary.text}
            </Button>
          ) : (
            <img onClick={handleCta} src={cta.primary.imageSource}></img>
          )}

          <Button className="w-full" onClick={handleHide} variant="secondary">
            {cta.secondary}
          </Button>
        </div>
      </Content>
    </Modal>
  )
}

const withContainer = compose(
  withRouter,
  connect((state, ownProps) => ownProps),
)

export default withContainer(PopupAds)
